

















import Vue from "vue";
import StuntSheetDot from "@/models/StuntSheetDot";
import Dot from "./Dot.vue";
import Show from "@/models/Show";

/**
 * Renders the field, the dots of the current stunt sheet, and pending dots
 * generated from the tool in use
 */
export default Vue.extend({
  name: "GrapherDots",
  components: {
    Dot,
  },
  computed: {
    showDotLabels(): boolean {
      return this.$store.state.showDotLabels;
    },
    selectedDotIds(): number[] {
      return this.$store.getters.getSelectedDotIds;
    },
    dotsWithLabels(): [string, StuntSheetDot][] {
      const show: Show = this.$store.state.show;
      return show.dotsWithLabelsForSS(
        this.$store.getters.getSelectedStuntIndex
      );
    },
    beat: {
      get(): number {
        return this.$store.getters.getBeat;
      },
    },
  },
});
